import script from "./ManagementHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./ManagementHeader.vue?vue&type=script&setup=true&lang=js"

import "./ManagementHeader.vue?vue&type=style&index=0&id=df63dff2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-df63dff2"]])

export default __exports__